import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async (id, selectedLocation) => {
    const { data: team, error: teamError } = await supabase
        .from('services_teams')
        .select(`*, services!inner(*)`)
        .eq('teams', id)
        .eq('services.service_location', selectedLocation)

    if (teamError) {
        throw new Error(teamError.message)
    }

    return team
}

export default function useGetServicesTeamsByTeamId(id, selectedLocation) {
    return useQuery({
        queryKey: ['useGetServicesTeamsByTeamId', id, selectedLocation],
        queryFn: () => getServices(id, selectedLocation),
        staleTime: 0,
    })
}


